import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PermitApprovalsSnackbars } from '../types/permit-approvals-snackbars.config';

@Injectable({
  providedIn: 'root',
})
export class PermitsApprovalsSnackbarsService {
  private readonly snackbar = inject(MatSnackBar);

  public successApprove(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.successApprove.message,
      PermitApprovalsSnackbars.successApprove.closeBtn,
      PermitApprovalsSnackbars.successApprove.config
    );
  }

  public successReject(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.successReject.message,
      PermitApprovalsSnackbars.successReject.closeBtn,
      PermitApprovalsSnackbars.successReject.config
    );
  }

  public failureNotActive(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureNotActive.message,
      PermitApprovalsSnackbars.failureNotActive.closeBtn,
      PermitApprovalsSnackbars.failureNotActive.config
    );
  }

  public failureNotAssigned(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureNotAssigned.message,
      PermitApprovalsSnackbars.failureNotAssigned.closeBtn,
      PermitApprovalsSnackbars.failureNotAssigned.config
    );
  }

  public failureAlreadyResolved(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureAlreadyResolved.message,
      PermitApprovalsSnackbars.failureAlreadyResolved.closeBtn,
      PermitApprovalsSnackbars.failureAlreadyResolved.config
    );
  }

  public failureValidation(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureValidation.message,
      PermitApprovalsSnackbars.failureValidation.closeBtn,
      PermitApprovalsSnackbars.failureValidation.config
    );
  }

  public failureNotEnoughBalance(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureNotEnoughBalance.message,
      PermitApprovalsSnackbars.failureNotEnoughBalance.closeBtn,
      PermitApprovalsSnackbars.failureNotEnoughBalance.config
    );
  }

  public failureOutsideGrantWindow(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureOutsideGrantWindow.message,
      PermitApprovalsSnackbars.failureOutsideGrantWindow.closeBtn,
      PermitApprovalsSnackbars.failureOutsideGrantWindow.config
    );
  }

  public failureGrantClosed(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureGrantClosed.message,
      PermitApprovalsSnackbars.failureGrantClosed.closeBtn,
      PermitApprovalsSnackbars.failureGrantClosed.config
    );
  }

  public successAssign(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.successAssign.message,
      PermitApprovalsSnackbars.successAssign.closeBtn,
      PermitApprovalsSnackbars.successAssign.config
    );
  }

  public failureAssignValidation(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureAssignValidation.message,
      PermitApprovalsSnackbars.failureAssignValidation.closeBtn,
      PermitApprovalsSnackbars.failureAssignValidation.config
    );
  }

  public failureNotCompanyAdmin(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureNotCompanyAdmin.message,
      PermitApprovalsSnackbars.failureNotCompanyAdmin.closeBtn,
      PermitApprovalsSnackbars.failureNotCompanyAdmin.config
    );
  }

  public failureInvalidApprover(): void {
    this.snackbar.open(
      PermitApprovalsSnackbars.failureInvalidApprover.message,
      PermitApprovalsSnackbars.failureInvalidApprover.closeBtn,
      PermitApprovalsSnackbars.failureInvalidApprover.config
    );
  }
}
